import { LanguageSelectorProps } from "@omni/ui/components/LanguageSelector/languageSelector.props";
import { FunctionComponent } from "react";

import { LanguageSelectorComponentProps } from "./languageSelector.types";
import LanguageDropDownSelector from "./layouts/dropdown/dropdown.component";
import LanguageListSelector from "./layouts/list/list.component";
import LanguageToggleSelector from "./layouts/toggle/toggle.component";

const LanguageSelectorConfig: Record<
    LanguageSelectorProps["layout"],
    FunctionComponent<LanguageSelectorComponentProps>
> = {
    default: LanguageDropDownSelector,
    list: LanguageListSelector,
    toggle: LanguageToggleSelector
};

const LanguageSelector = ({
    layout = "default",
    variant,
    color
}: LanguageSelectorProps) => {
    const Component = LanguageSelectorConfig[layout];

    return (
        <Component
            variant={variant}
            color={color}
        />
    );
};

export default LanguageSelector;
